/**
 * Module: Utils
 *
 * @author PH|MC
 */

export const lightboxGallery = function() {
  $('[data-toggle="lightbox"]').click(function(e) {
    e.preventDefault();
    $(this).ekkoLightbox();
  });
};

export const mobileNavigation = function() {
  $('#navbar-toggle').click(function() {
    $(this).toggleClass('active');
    $('body').toggleClass('mobile-nav-active');
    $('#mobile-navigation').toggleClass('active');
  });
};

export const smoothScroll = function() {
  $('body').on('click', 'a[href*="#"]', function(e) {
    var hash = this.hash;
    if ('' !== hash) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 100,
      });
    }
  });
};

export const stickynavigation = function() {
  if ($('#main-navigation').hasClass('navbar-fixed')) {
    $('body').addClass('fixed-nav-active');

    $(window).scroll(function() {
      if ($(window).scrollTop() > $('#main-navigation').outerHeight()) {
        $('.navbar-custom').addClass('is-fixed is-visible');
      } else {
        $('.navbar-custom').removeClass('is-visible is-fixed');
      }
    });
  }
};
